import React from "react";
import Container from "react-bootstrap/Container";
import Jumbotron from "react-bootstrap/Jumbotron";
import Card from "react-bootstrap/Card";
import JioLogo from "../../assets/img/experience/jioIcon.png";
import IhsLogo from "../../assets/img/experience/ihsMarkit.png";
import MdsLogo from "../../assets/img/experience/mds.png";
import Tilt from "react-tilt";
import "./experience.styles.css";

const Experience = () => {
  return (
    <div>
      <h1 className="text-center font-details-b pb-3">EXPERIENCE</h1>
      <Jumbotron className="jumbo-style">
        <Container>
          <Tilt options={{ max: 25 }}>
            <Card>
              <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                <Card.Img variant="top" className="img-resize" src={JioLogo} alt="Jio logo" />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <Card.Title className="text-center">Team Lead</Card.Title>
                <div>
                  <Card.Text className="text-center style">
                    <strong>Role:</strong> Web Developer
                    <br />
                    <strong>Description:</strong> Worked on the flagship website jio.com with the stack of the application is React based, made on the Nextjs Framework, making it an Isomorphic website. An individual
person’s initiative by working on the app from scratch, and building a team simultaneously.
                    <br />
                    <strong>Technology:</strong> React, Javascript, NextJs, GatsbyJs, Emotion, HTML, CSS, Jest
                    <br />
                    <strong>Duration:</strong> May 2019 - Present
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Tilt>
        </Container>
        <br /><br /><br />
        <Container>
          <Tilt options={{ max: 25 }}>
            <Card>
              <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                <Card.Img variant="top" className="img-Markit" src={IhsLogo} alt="IHS Markit logo" />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <Card.Title className="text-center">Software Engineer</Card.Title>
                <div>
                  <Card.Text className="text-center style">
                    <strong>Role:</strong> Frontend Developer
                    <br />
                    <strong>Description:</strong> Worked on the main Project MarkitServ (TradeServ Unification) as an Individual Contributor, for a SPA for credit and FX trade confirmation, clearing and regulatory reporting services.
                    <br />
                    <strong>Technology:</strong> Typescript, Angular, AngularJs, Webpack, SASS, HTML, CSS, Mocha
                    <br />
                    <strong>Duration:</strong> May 2017 - April 2019
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Tilt>
        </Container>
        <br /><br /><br />
        <Container>
          <Tilt options={{ max: 25 }}>
            <Card>
              <Card.Header as="h5" className="d-flex justify-content-center flex-wrap">
                <Card.Img variant="top" className="img-Markit" src={MdsLogo} alt="IHS Markit logo" />
              </Card.Header>
              <Card.Body className="d-flex justify-content-center flex-column">
                <Card.Title className="text-center">Sr. Software Engineer</Card.Title>
                <div>
                  <Card.Text className="text-center style">
                    <strong>Role:</strong> Frontend Developer
                    <br />
                    <strong>Description:</strong> Worked on projects from multiple domains like health, e-commerce, banking, hospitality, etc. providing an exposure of multiple ecosystems.
                    <br />
                    <strong>Technology:</strong> EmberJs, AngularJs, Vanilla JS, Grunt, HTML, CSS
                    <br />
                    <strong>Duration:</strong> Sept 2013 - April 2017
                  </Card.Text>
                </div>
              </Card.Body>
            </Card>
          </Tilt>
        </Container>
      </Jumbotron>
    </div>
  );
};

export default Experience;
